import jQuery from 'jquery';

jQuery(function ($) {
  //--------------------------------------------------
  // Get populated sections

  $('.is-active').each(function (i) {
    var id = $(this).attr('id');
    $('#sort_index_' + id).html('<a href="#' + id + '">' + id + '</a>');

    // Default state is too show all
    if ($('.js-sort-index-target').hasClass('js-show-all')) {
      $('.js-sort-index-target .target').addClass('js-current');
    } else {
      if (i === 0) {
        // Else add active state to first anchor that is available
        $('#sort_index_' + id).html(
          '<a href="#' + id + '" class="active">' + id + '</a>',
        );
      }
    }
  });

  //--------------------------------------------------
  // Show selected target section

  $('.index a').on('click', function (e) {
    e.preventDefault();
    var target = $(this).attr('href');
    $('.index a').removeClass('active');
    $(this).addClass('active');
    $('.js-sort-index-target .target').removeClass('js-current');
    $(target).addClass('js-current');

    if ($('.js-sort-index-target').hasClass('js-show-all')) {
      if ($('.show-all').length == 0) {
        $('.index').append('<a href="#" class="show-all">Clear</a>');
      }

      $('.show-all').on('click', function (e) {
        e.preventDefault();
        $('.js-sort-index-target .target').addClass('js-current');
        $('.index a').removeClass('active');
        $(this).remove();
      });
    }
  });
});
